/** A gateway station's name, which is the gateway's to set.
 *
 *  The gateway-unreachable notice that used to live here is a station
 *  alert now (`source_failing`, lib/health.ts, intake v2 phase 5).
 */

/** Whether a station's name is the gateway's to set. The worker mirrors a
 *  CMT gateway's network name every telemetry poll and the API refuses an
 *  edit (services/gateway_names.py), so the form shows it read-only. An
 *  MDS station keeps an editable name: MDS sends none to follow. */
export function nameFollowsGateway(vendor: string | undefined): boolean {
  return vendor === 'cmt_edge'
}

export const GATEWAY_NAME_NOTE = "Follows the gateway's network name. "
  + 'Rename the network in Loadsensing and it changes here within five minutes.'
